// SearchBar.js
import React, { useState, useEffect, useCallback, useRef } from 'react';
import axios from 'axios';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import searchicon from '../images/search-pic.png';
import search1 from '../images/search-1.svg';
import { useUser } from '../context/UserContext';
import debounce from 'lodash.debounce';
import '../searchstyles.css';

const SearchBar = ({ onNavigate }) => {
  const [searchResults, setSearchResults] = useState([]);
  const [isFocused, setIsFocused] = useState(false);
   const {
  user,
  isLoggedIn,
  logout,
  searchHistory,  // array of last 5 tickers
  addSearch,      // fn to push a new ticker
  clearHistory,   // fn to reset history
  theme,          // 'light' | 'dark'
  setTheme,
  language,       // e.g. 'en'
  setLanguage
} = useUser();
  const location = useLocation(); // Get the current location
const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  // If the current path is "/scanner", don't show the search bar

  const handleResultPointerDown = (
  event,
  symbol,
  logoUrl,
  securityName
) => {
  event.preventDefault();
  event.stopPropagation();

  if (blurTimeout.current) {
    clearTimeout(blurTimeout.current);
  }

  handleSelect(symbol, logoUrl, securityName);
};
    useEffect(() => {
    console.log("runs");
    const handleResize = () => {
    console.log("handling");
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      if (mobile) {
      console.log("mobile");
        
      } else {
      console.log("desktop");
      
    }
    };
  
    // Invoke handleResize on component mount
    handleResize();
  
    // Add event listener for window resize
    window.addEventListener('resize', handleResize);
  
    // Cleanup event listener on component unmount
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  /*if (location.pathname === '/scanner') {
    return null;
  }*/ const blurTimeout = useRef(null);
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const navigate = useNavigate();

  // Fetch matching stocks from our backend
  const fetchResults = async (q) => {
    if (!q) { 
      setResults([]);
      return;
    }
    try {
      const { data } = await axios.get('https://stocksleuth.xyz:5000/auth/search', { params: { query: q } });
      // Convert binary logo to base64 data URL
      const formatted = data.results.map((item) => {
        let logoUrl = null;
        if (item.logo && item.logo.data) {
          const logoBuffer = new Uint8Array(item.logo.data);
          const base64Logo = btoa(String.fromCharCode.apply(null, logoBuffer));
          logoUrl = `data:image/png;base64,${base64Logo}`;
        }
        return {
          symbol: item.symbol,
          security_name: item.security_name,
          logoUrl,
        };
      });
      setResults(formatted);
    } catch (error) {
      console.error('Search error:', error);
    }
  };

  // Debounce the fetch to avoid excessive calls
  const debouncedFetch = useCallback(debounce(fetchResults, 200), []);

  useEffect(() => {
    debouncedFetch(query);
    // Cleanup on unmount or query change
    return debouncedFetch.cancel;
  }, [query, debouncedFetch]);

// accept both params…
const handleSelect = (symbol, logoUrl, securityName) => {
  // Cancel the blur timeout so it doesn’t fire mid-click
  if (blurTimeout.current) clearTimeout(blurTimeout.current);

  // Add search history
  addSearch({ symbol, name: securityName, logoUrl });

  // Close the dropdown immediately
  setIsFocused(false);
  onNavigate?.();

  // Navigate to the stock page
  navigate(`/stock/${symbol}`);
};


	/*const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };*/
const handleShowMore = () => {
  if (blurTimeout.current) clearTimeout(blurTimeout.current);
  setIsFocused(false); // close dropdown
  onNavigate?.();
  navigate(`/search/${encodeURIComponent(query)}`);
};


  const displayResults = results.slice(0, 5);

const modifySecurityName = (name) => {
    return name
      .replace(/ - Common Stock$/, "")
      .replace(/ Common Stock$/, "")
      .replace(/ Capital Stock$/, "")
      .replace(/ Ordinary Shares$/, "")
      .replace(/ - Common Shares$/, "")
      
      .replace(/ Inc.$/, "")
      .replace(/,$/, "");
  };

  return (
    <div>
      

		<div>
		
		
		
		<div className="bar" >
		<div className="search" >
		<div className="overlap-group" >
    {isFocused && (
        <div
        
          style={{
            borderRadius: "14px",
            position: "absolute",
            top: "-5px", // Move 3px up
            left: "-5px", // Move 3px left
            right: "-5px", // Expand 3px right
            bottom: "-5px", // Expand 3px down
            border: "3px solid rgba(235, 235, 235, 0.53)",
            pointerEvents: "none", // Prevent blocking interactions
            zIndex: "-1", // Keep it behind the input
          }}
        />)}
      
		<input onFocus={() => setIsFocused(true)}
        onBlur={() => {
          blurTimeout.current = setTimeout(() => setIsFocused(false), 100);
        }}spellcheck="false" placeholderStyle={{ color: '#808EF6' }} className="div" placeholder="Search Companies" type="text" value={query}
        onChange={(e) => setQuery(e.target.value)}
		/>
		<img className="img" alt="Search" src={search1} />
		</div>
{isFocused && !query && searchHistory.length > 0 && (
  <div
    className="search-results"
    style={{
      marginTop: "20px",
      left: "0",
      right: "0",
      zIndex: "1000",
      width: isMobile ? "90vw" : "280%",
      backgroundColor: "white",
      borderRadius: "18px",
      padding: "10px",
      boxShadow: "rgb(138 139 140 / 50%) 0px 0px 60px",
      position: "absolute",
      top: "100%",
      left: "50%",
      transform: "translateX(-50%)"
    }}
  >
    <ul className="results-list">
      {searchHistory.map((item, idx) => (
        <li
        key={`${item.symbol}-${idx}`}
  onPointerDown={(event) =>
    handleResultPointerDown(
      event,
      item.symbol,
      item.logoUrl,
      item.name
    )
  }
          className="searchRow"
          style={{
            display: "flex",
            flexDirection: "row",
            padding: "10px 14px",
            cursor: "pointer",
            alignItems: "center"
          }}
        >
          {item.logoUrl ? (
            <img
              className="logoSmallAlt"
              src={item.logoUrl}
              alt={`${item.symbol} logo`}
              style={{ width: 30, height: 30, objectFit: "contain" }}
            />
          ) : (
            <div
              className="logoSmallAlt"
              style={{
                width: 30,
                height: 30,
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
              }}
            >
              <p
                style={{
                  fontSize: 14,
                  color: "#9c9c9c",
                  fontWeight: 600,
                  margin: 0
                }}
              >
                {item.symbol.charAt(0)}
              </p>
            </div>
          )}
          <div
            style={{
              marginLeft: "10px",
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start"
            }}
          >
            <p style={{ margin: 0, fontSize: isMobile ? 12 : 14, fontWeight: 500 }}>
              {modifySecurityName(item.name)}
            </p>
            <p style={{ margin: 0, fontSize: isMobile ? 9 : 10, marginTop: 2, color: "#9197b3" }}>
              {item.symbol}
            </p>
          </div>
        </li>
      ))}
    </ul>
  </div>
)}



    {(results.length > 0 && isFocused) && (
       <div className="search-results" style={{ marginTop: "20px", left: "0", right: "0", zIndex: "1000", width: isMobile ? "90vw" : "280%", backgroundColor: "white", borderRadius: "18px", padding: "10px", boxShadow: "rgb(138 139 140 / 50%) 0px 0px 60px", position: "absolute", top: "100%", left: "50%", transform: "translateX(-50%)" }}>
        <ul className="results-list">
          {displayResults.map((item) => (
           <li
  key={item.symbol}
  className="searchRow"
  onPointerDown={(event) =>
    handleResultPointerDown(
      event,
      item.symbol,
      item.logoUrl,
      item.security_name
    )
  }
  style={{
    display: "flex",
    flexDirection: "row",
    padding: "10px 14px",
    marginBottom: 2,
    cursor: "pointer",
    alignItems: "center",
  }}
>
               {item.logoUrl ? ( 
                <img style={{width: 30, height: 30, objectFit: "contain"}}src={item.logoUrl} alt={`${item.symbol} logo`} className="logoSmallAlt" />) : (<><div className="logoSmallAlt" style={{width: 30, height: 30}}>
                                    <p
                                      style={{
                                        fontSize: 14,
                                        color: "#9c9c9c",
                                        fontWeight: 600,
                                        margin: 0,
                                      }}
                                    >
                                      {item.symbol
                                        ? item.symbol[0]
                                        : ""}
                                    </p>
                                  </div></>
                                )}
                                  <div style={{ marginLeft: "10px", display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
                                  <p style={{margin: 0, fontSize: isMobile ? 12 : 14}}>{modifySecurityName(item.security_name)}</p>
              
              <p style={{margin: 0, fontSize: isMobile ? 9 : 10, marginTop: 3, color: "#9197b3"}}>{item.symbol}</p>
              </div>
              
            </li>
          ))}
          {results.length > 5 && (
            <div  className="searchRow" onClick={handleShowMore}style={{display: "flex", flexDirection: "row", padding: "10px", cursor: "pointer", alignItems: "center", justifyContent: "center"}}>
            <li className="show-more" onClick={handleShowMore} style={{fontSize: 10, margin: 0}}>
              Show more results...
            </li></div>
          )}
        </ul></div>
      )}
		</div>
		</div>
	  
	  
	  
      </div>
    
    </div>
  );
};

export default SearchBar;
